import { Request } from '../../../httpClient/serverApi/requests/Request';

// changing passwords
// Passwords should be encrypted client-side using the same technique as the login page.
// The server should first validate that oldPassword matches the users current password.
// If it does, the server should update the user's password to the new value.
// old password is optional if the user is a server admin and is not changing their own password.
export interface IChangeUserPasswordParams {
  userId: string;
  oldEncryptedPassword?: string;
  newEncryptedPassword: string;
  keyId: string;
}

export interface IChangeUserPasswordResult {
}

export class ChangeUserPasswordRequest extends Request<IChangeUserPasswordParams, IChangeUserPasswordResult> {
  constructor(params: IChangeUserPasswordParams) {
    super('changeUserPassword', params);
  }
}
